/**
 * getPreviewURL returns the cloud storage URL for a given GAD media id
 */
export const getPreviewURL = (
    id,
    type = 'thumbnail',
    bucket = 'aps-storage-prod-z8a0rssq',
) => {
    if (id == null || id.length === 0) {
        return null;
    }

    // [1] Split attachment-id into archiv and media-number
    try {
        if (id.split('M').length > 1) {
            const [archiv, medium] = id.split('M');
            const chunks = medium.match(/.{1,2}/g);

            // Limit the chunk size for extra long filenames
            chunks.length = 4;

            // [2] Replace last chunk with the attachment-id + file extension
            chunks[chunks.length - 1] = id;

            // [3] Join chunks and construct path
            const path = [archiv, ...chunks].join('/');

            return `https://storage.googleapis.com/${bucket}/gad_private_production/medien/${type}/${path}.jpg`;
        } else if (id.indexOf('_') > -1) {
            let archiv, medium;

            if (id.slice(0, 3) === 'KR_') {
                archiv = 'KR_';
                medium = id.slice(3);
            } else {
                archiv = id.slice(0, id.indexOf('_'));
                medium = id.slice(id.indexOf('_'));
            }

            const path =
                archiv +
                '/' +
                medium.slice(0, 2) +
                '/' +
                medium.slice(2, 4) +
                '/' +
                medium.slice(4, 6) +
                '/' +
                id;
            return `https://storage.googleapis.com/${bucket}/gad_private_production/medien/${type}/${path}.jpg`;
        }
    } catch (err) {
        return null;
    }
};